import React from "react";
import Routes from "./Routes";

/**
 * Users Component
 */
export default () => {
    return <Routes />;
};
